export default __webpack_public_path__ + "static/aquaventure-d904f712429a41e7ddfc3582e13f802e.webp";